import $ from 'jquery'

$(document).on('turbo:load', () => {
  // A failed create renders the form again, with the report type that was chosen
  if ($('body.reports_schedules-new, body.reports_schedules-create').length === 0) return

  const selectDataAcquisitionType = $('select#reports_schedule_report_type')

  const inspectionAdministeredByFormGroup = $('#reports_schedule_administered_by').parent()
  const serviceGroupCategoryFormGroup = $('#reports_schedule_service_group_category_id').parent()

  selectDataAcquisitionType.on('change', () => {
    // Show ServiceGroupCategory select only when Inspection reports are selected
    if (selectDataAcquisitionType.val() === 'inspections' || selectDataAcquisitionType.val() === 'defect_inspections') {
      inspectionAdministeredByFormGroup.show()
      serviceGroupCategoryFormGroup.show()
    } else {
      inspectionAdministeredByFormGroup.hide()
      serviceGroupCategoryFormGroup.hide()
    }
  })

  // Also apply it to the report type the page comes with
  selectDataAcquisitionType.trigger('change')
})
